import React from "react";
import {
  Row,
  Col,
  Card,Container
} from "react-bootstrap";
import './Payments.scss';

import { ReactComponent as First } from "../../assets/images/Icons_descargar.svg";
import  Pasos from "./../../assets/images/Mailing_Medios de pago.jpg";

function Payments( ) {
  return (
    <div>


       
      
      <div className="fq-header wrapper">
        <span className="fq-title" style={{ marginTop: 60 }}>
        Paga tu cuota desde nuestra web
        </span>
      </div>
<Container>
     
     
  <a href="https://pagos.sistemaffcc.com/" target="_blank" rel="noopener noreferrer">
   <Row style={{ paddingLeft: "12%", paddingRight: "12%",paddingTop: "30px" }}>
          <img src={Pasos} alt="Pasos" /></Row>
        </a>
   
                      </Container>
    </div>
  );
}

export default Payments;
